import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "drawer"]

  // Close on escape key
  connect() {
    this.handleEscape = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.handleEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape)
  }
  
  toggle() {
    if (this.overlayTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.overlayTarget.classList.remove("hidden")
    // Force reflow before adding the transform
    this.drawerTarget.offsetHeight
    // Slide up the drawer
    requestAnimationFrame(() => {
      this.drawerTarget.classList.remove("translate-y-full")
      this.drawerTarget.classList.add("translate-y-0")
    })
    // Prevent body scroll
    document.body.style.overflow = "hidden"
  }

  close() {
    this.drawerTarget.classList.remove("translate-y-0")
    this.drawerTarget.classList.add("translate-y-full")
    
    // Wait for animation to complete before hiding
    setTimeout(() => {
      this.overlayTarget.classList.add("hidden")
    }, 300)
    
    // Restore body scroll
    document.body.style.overflow = ""
  }

  handleEscape(event) {
    if (event.key === "Escape" && !this.overlayTarget.classList.contains("hidden")) {
      this.close()
    }
  }
}